import React from "react";

const Services = () => {
  return (
    <section className="content mb-5">
      <div className="container-fluid">
        <div className="row titlepad">
          <div className="col-md-12">
            <div className="mt-3 mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>

            <div className="row align-items-end">
              <div className="col-sm-9">
                <h4>Services</h4>
                <p className="page-sub-head">Showing 1 to 10 of 57 list</p>
                <a
                  href="../vendor-admin/ServicesDetails"
                  className="btn-md btn-primary d-inline-block"
                >
                  {" "}
                  <i className="fa-solid fa-user-plus"></i> Add More{" "}
                </a>
                {/* <a href="category.html" className="btn-md btn-warning d-inline-block"><i className="fa fa-cubes"></i> Category</a> */}
                <a href="#" className="btn-md btn-info d-inline-block">
                  <i className="fa-regular fa-file-excel"></i> Export
                </a>
                <a
                  href="#"
                  // data-toggle="modal"
                  // data-target="#filter"
                  className="btn-md btn-dark d-inline-block"
                >
                 <i className="fa-solid fa-filter"></i> Filter
                </a>
              </div>
              <div className="col-md-3">
                <input
                  className="form-control searchinput"
                  type="text"
                  placeholder="Search Services..."
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <div className="dashbed-border-bottom"></div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card package-section">
              <div className="row">
                <div className="col-12">
                  <h5>BRAIDS</h5>
                  <h6>Created on: 04-07-2023</h6>
                  <p>
                    SAR 200 <strike>SAR 300</strike>{" "}
                    <span className="badge badge-secondary">10%</span>
                  </p>
                  <div className="grid-status">
                    <span className="badge bad-status badge-warning">
                      Pending
                    </span>
                  </div>
                </div>
                <div className="col-md-12 pack-details">
                  <p>Category Included</p>
                  <h5>Natural Hair, Locs, Haircut, Silk Press</h5>
                </div>
                <div className="col-md-6 pack-details">
                  <p>Ideal Time</p>
                  <h5>15 min</h5>
                </div>
                <div className="col-md-6 pack-details">
                  <p>Service For</p>
                  <h5>
                    <strong>Center</strong>
                  </h5>
                </div>
                <div className="col-md-12 d-flex justify-content-between pack-action">
                  <a href="#" className="btn-md card-btn btn-outline-secondary">
                    <i className="fa-solid fa-trash"></i> Delete
                  </a>
                  <a
                    href="../vendor-admin/ServicesDetails"
                    className="btn-md card-btn btn-primary"
                  >
                    <i className="fa fa-eye"></i>
                    View
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card package-section">
              <div className="row">
                <div className="col-12">
                  <h5>NATURAL HAIR</h5>
                  <h6>Created on: 04-07-2023</h6>
                  <p>
                    SAR 200 <strike>SAR 300</strike>{" "}
                    <span className="badge badge-secondary">10%</span>
                  </p>
                  <div className="grid-status">
                    <span className="badge bad-status badge-danger">
                      Inactive
                    </span>
                  </div>
                </div>
                <div className="col-md-12 pack-details">
                  <p>Category Included</p>
                  <h5>Natural Hair, Locs, Haircut, Silk Press</h5>
                </div>
                <div className="col-md-6 pack-details">
                  <p>Ideal Time</p>
                  <h5>15 min</h5>
                </div>
                <div className="col-md-6 pack-details">
                  <p>Service For</p>
                  <h5>
                    <strong>Home</strong>
                  </h5>
                </div>
                <div className="col-md-12 d-flex justify-content-between pack-action">
                  <a href="#" className="btn-md card-btn btn-outline-secondary">
                    <i className="fa-solid fa-trash"></i> Delete
                  </a>
                  <a
                    href="../vendor-admin/ServicesDetails"
                    className="btn-md card-btn btn-primary"
                  >
                    <i className="fa fa-eye"></i>
                    View
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card package-section">
              <div className="row">
                <div className="col-12">
                  <h5>HAIRCUT</h5>
                  <h6>Created on: 04-07-2023</h6>
                  <p>
                    SAR 200 <strike>SAR 300</strike>{" "}
                    <span className="badge badge-secondary">10%</span>
                  </p>
                  <div className="grid-status">
                    <span className="badge bad-status badge-success">
                      Active
                    </span>
                  </div>
                </div>
                <div className="col-md-12 pack-details">
                  <p>Category Included</p>
                  <h5>Natural Hair, Locs, Haircut, Silk Press</h5>
                </div>
                <div className="col-md-6 pack-details">
                  <p>Ideal Time</p>
                  <h5>15 min</h5>
                </div>
                <div className="col-md-6 pack-details">
                  <p>Service For</p>
                  <h5>
                    <strong>Center</strong>
                  </h5>
                </div>
                <div className="col-md-12 d-flex justify-content-between pack-action">
                  <a href="#" className="btn-md card-btn btn-outline-secondary">
                    <i className="fa-solid fa-trash"></i> Delete
                  </a>
                  <a
                    href="../vendor-admin/ServicesDetails"
                    className="btn-md card-btn btn-primary"
                  >
                    <i className="fa fa-eye"></i>
                    View
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card package-section">
              <div className="row">
                <div className="col-12">
                  <h5>MEN'S HAIRCUT</h5>
                  <h6>Created on: 04-07-2023</h6>
                  <p>
                    SAR 200 <strike>SAR 300</strike>{" "}
                    <span className="badge badge-secondary">10%</span>
                  </p>
                  <div className="grid-status">
                    <span className="badge bad-status badge-success">
                      Active
                    </span>
                  </div>
                </div>
                <div className="col-md-12 pack-details">
                  <p>Category Included</p>
                  <h5>Natural Hair, Locs, Haircut, Silk Press</h5>
                </div>
                <div className="col-md-6 pack-details">
                  <p>Ideal Time</p>
                  <h5>15 min</h5>
                </div>
                <div className="col-md-6 pack-details">
                  <p>Service For</p>
                  <h5>
                    <strong>Home</strong>
                  </h5>
                </div>
                <div className="col-md-12 d-flex justify-content-between pack-action">
                  <a href="#" className="btn-md card-btn btn-outline-secondary">
                    <i className="fa-solid fa-trash"></i> Delete
                  </a>
                  <a
                    href="../vendor-admin/ServicesDetails"
                    className="btn-md card-btn btn-primary"
                  >
                    <i className="fa fa-eye"></i>
                    View
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card package-section">
              <div className="row">
                <div className="col-12">
                  <h5>LOCS</h5>
                  <h6>Created on: 04-07-2023</h6>
                  <p>
                    SAR 200 <strike>SAR 300</strike>{" "}
                    <span className="badge badge-secondary">10%</span>
                  </p>
                  <div className="grid-status">
                    <span className="badge bad-status badge-danger">
                      Inactive
                    </span>
                  </div>
                </div>
                <div className="col-md-12 pack-details">
                  <p>Category Included</p>
                  <h5>Natural Hair, Locs, Haircut, Silk Press</h5>
                </div>
                <div className="col-md-6 pack-details">
                  <p>Ideal Time</p>
                  <h5>15 min</h5>
                </div>
                <div className="col-md-6 pack-details">
                  <p>Service For</p>
                  <h5>
                    <strong>Center</strong>
                  </h5>
                </div>
                <div className="col-md-12 d-flex justify-content-between pack-action">
                  <a href="#" className="btn-md card-btn btn-outline-secondary">
                    <i className="fa-solid fa-trash"></i> Delete
                  </a>
                  <a
                    href="../vendor-admin/ServicesDetails"
                    className="btn-md card-btn btn-primary"
                  >
                    <i className="fa fa-eye"></i>
                    View
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card package-section">
              <div className="row">
                <div className="col-12">
                  <h5>SILK PRESS</h5>
                  <h6>Created on: 04-07-2023</h6>
                  <p>
                    SAR 200 <strike>SAR 300</strike>{" "}
                    <span className="badge badge-secondary">10%</span>
                  </p>
                  <div className="grid-status">
                    <span className="badge bad-status badge-warning">
                      Pending
                    </span>
                  </div>
                </div>
                <div className="col-md-12 pack-details">
                  <p>Category Included</p>
                  <h5>Natural Hair, Locs, Haircut, Silk Press</h5>
                </div>
                <div className="col-md-6 pack-details">
                  <p>Ideal Time</p>
                  <h5>15 min</h5>
                </div>
                <div className="col-md-6 pack-details">
                  <p>Service For</p>
                  <h5>
                    <strong>Home</strong>
                  </h5>
                </div>
                <div className="col-md-12 d-flex justify-content-between pack-action">
                  <a href="#" className="btn-md card-btn btn-outline-secondary">
                    <i className="fa-solid fa-trash"></i> Delete
                  </a>
                  <a
                    href="../vendor-admin/ServicesDetails"
                    className="btn-md card-btn btn-primary"
                  >
                    <i className="fa fa-eye"></i>
                    View
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="pagination_rounded">
            <ul>
              <li>
                <a href="#" className="prev">
                  {" "}
                  <img src="/img/back.svg" />{" "}
                </a>
              </li>
              <li className="active">
                <a href="#">1</a>{" "}
              </li>
              <li className="hidden-xs">
                <a href="#">2</a>{" "}
              </li>
              <li className="hidden-xs">
                <a href="#">3</a>{" "}
              </li>
              <li className="visible-xs">
                <a href="#">...</a>{" "}
              </li>
              <li>
                <a href="#">32</a>{" "}
              </li>
              <li>
                <a href="#" className="next">
                  {" "}
                  <img src="/img/back.svg" />{" "}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
